module.exports = "<div class=\"container\">\r\n\r\n  <app-sidenav [program]=\"program\"></app-sidenav>\r\n\r\n  <main>\r\n    <app-title-header *ngIf=\"!loading\" [program]=\"program\" [title]=\"navbarData.title\" [color]=\"navbarData.color\" [crumbs]=\"navbarData.crumbs\"></app-title-header>\r\n\r\n    <div class=\"body\">\r\n      <router-outlet></router-outlet>\r\n    </div>\r\n  </main>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/program-container/program-container.component.html
// module id = ./src/app/components/program-container/program-container.component.html
// module chunks = main